import script from "./EditableTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditableTable.vue?vue&type=script&lang=ts&setup=true"

import "./EditableTable.vue?vue&type=style&index=0&id=20fe8120&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20fe8120"]])

export default __exports__